import React from "react";
import { Gift, Users, Bell, X, CheckCircle, AlertTriangle, Info } from "lucide-react";
import { useLanguage } from '../context/LanguageContext';

/**
 * NotificationsOverlay - Muestra notificaciones in-app como toasts animados
 */
export default function NotificationsOverlay({ notifications, onDismiss }) {
  const { language } = useLanguage();
  const es = language === 'es';
  if (!notifications || notifications.length === 0) return null;

  const getIcon = (type) => {
    switch (type) {
      case "success":
        return <CheckCircle className="w-5 h-5" />;
      case "warning":
        return <AlertTriangle className="w-5 h-5" />;
      case "referral":
        return <Users className="w-5 h-5" />;
      case "bonus":
        return <Gift className="w-5 h-5" />;
      default:
        return <Info className="w-5 h-5" />;
    }
  };

  const getStyles = (type) => {
    switch (type) {
      case "success":
        return "bg-emerald-600 border-emerald-500";
      case "warning":
        return "bg-amber-600 border-amber-500";
      case "referral":
        return "bg-cyan-600 border-cyan-500";
      case "bonus":
        return "bg-purple-600 border-purple-500";
      case "error":
        return "bg-red-600 border-red-500";
      default:
        return "bg-slate-700 border-slate-600";
    }
  };

  return (
    <div className="fixed top-4 right-4 z-[9999] space-y-3 max-w-sm">
      {notifications.map((n) => (
        <div
          key={n.id}
          className={`
            flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg text-white border
            transform transition-all duration-300 ease-out
            animate-in slide-in-from-right-5 fade-in
            ${getStyles(n.type)}
          `}
          role="alert"
          data-testid={`notification-${n.type}`}
        >
          <div className="flex-shrink-0">
            {getIcon(n.type)}
          </div>
          <p className="flex-1 text-sm font-medium">{n.message}</p>
          {onDismiss && (
            <button
              onClick={() => onDismiss(n.id)}
              className="flex-shrink-0 p-1 hover:bg-white/20 rounded-full transition-colors"
              aria-label={es ? 'Cerrar notificación' : 'Close notification'}
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
